import cta from '~/components/atoms/a-ctas/a-cta-v2.data'
import feature from '~/components/molecules/m-cards/m-card-feature.data'
import card from '~/components/molecules/m-cards/m-card.data'

export default {
  heading: 'Thinking.',
  heading_podcasts: 'Latest Podcasts.',
  cta: [
    {
      ...cta,
      copy: 'View all',
      href: {
        url: '/articles',
        cached_url: '/articles',
      },
      type: 'primary',
    },
  ],
  feature: [feature],
  podcasts: [
    {
      ...card,
      podcast: true,
      heading:
        "Brand experience in a crisis - how to do it and why you absolutely mustn't just stop",
      copy: 'At Tribal, our creative heritage stretches all the way back to the pioneers of modern advertising and connects us to one of the world’s largest creative networks.',
      image: {
        alt: 'Entry image.',
        filename:
          '//a.storyblok.com/f/46530/1480x833/edbca44c51/01-hero-adidasrunning-001.png',
      },
      cta: [
        {
          ...cta,
          copy: 'Subscribe Now',
          type: 'secondary',
        },
      ],
    },
  ],
  component: 'o-featured-articles',
}
